export const OrderStatusCssClasses = {
  0: "warning",
  1: "success",
  2: "primary",
} as const;
export type OrderStatusCssClassesType = keyof typeof OrderStatusCssClasses;

export const OrderStatusTitles = {
  0: "ثبت اولیه",
  1: "ثبت نهایی",
  2: "ارسال شده",
};

export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 },
];

export const initialFilter = {
  filter: {
    name: "",
  },
  sortOrder: "asc",
  sortField: "name",
  pageNumber: 1,
  pageSize: 10,
};

export const InventoryTitles = {
  0: "خشک",
  1: "روزانه",
  2: "یخچالی",
  3: "ضایعات",
  4: "دیگر انبار ها"
}
